// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

import { slideUp,
         shortDuration } from "helpers/animations";

export default class OverviewTable extends PureComponent {
  render({ grandTotal, items }, _state, { t, formatPrice }) {
    return (
      <table
        class={classNames(
          this.props["class"],
          slideUp,
          shortDuration,
          styles.table
        )}>

        <thead>
          <tr>
            <th>{t("CHECKOUT.ARTICLE")}</th>
            <th>{t("CHECKOUT.AMOUNT")}</th>
            <th>{t("CHECKOUT.PRICE")}</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item =>
            <tr>
              <td>{item.product.name}</td>
              <td>{item.qty}</td>
              <td>{formatPrice(item.product.price * item.qty)}</td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr>
            <td class={styles.total}>{t("CHECKOUT.TOTAL")}</td>
            <td></td>
            <td>{formatPrice(grandTotal)}</td>
          </tr>
        </tfoot>
      </table>
    );
  }
}
